<template>
  <div class="review" :courseId="courseId" style="text-align:center">
     <!-- <img src="../../../../static/image/defaultpic.png" alt="" />  -->
    <p class="noData" v-if="commentList.length===0"></p>
     <ul v-else class="reviewCont">
      <li v-for="item in commentList">
        <div style="float:left;width:80%">
        <img :src="item.img" alt="" @error="changeToDefaultImg(item)" />

          <div class="paramCont">
            <div class="topRow">
              <span class="paramName">{{item.creatorNeme}}</span>
              <span class="star">
                  <el-rate
                    v-model="item.starGrade"
                    disabled-void-color = "rgb(198, 209, 222)"
                    disabled>
                  </el-rate>
            </span>
          </div>
        </div>
     </div>
            <div class="paramTime">{{item.createDate}}</div>

          <div v-if="item.content!==undefined" style="clear: both;float: left;margin-left: 7%;" class="paramTxt" :title="item.content">{{maxSlice(item.content)}}</div>
          <div v-else  style="clear: both;float: left;margin-left: 7%;">该学员没有填写评价内容</div>

      </li>
    </ul>
    <!--分页-->
    <page :total="page.total" :allPage="page.allPage" :currentPage="page.currentPage" @current-page="__currentPage"
          @page-size="__pageSize" :pageSize="page.pageSize"></page>
  </div>
</template>

<script type="text/ecmascript-6">
  import page from '@/components/common/page/page'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {nomalTime} from '@/common/js/time'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import defalutImg from "@/assets/images/user.png";
  export default {
    props: {
      courseId: {
        type: String,
        default: ''
      }
    },
    components: {
      page
    },
    data() {
      return {
        value5: 4,
        commentList:[],
        changeContent:'',
        page: {
          currentPage: 1,
          pageSize: 10,
          total: 0,
          allPage: 0,
        },

      }
    },
    mounted() {

    },
    methods: {
      changeToDefaultImg(item){
        item.img = defalutImg;
      },
      maxSlice(val){
        let lent = val.length
        if(lent > 128){
          let slicedTxt = val.slice(0,128) + '...'
          return slicedTxt
          // this.changeContent = slicedTxt
        }else{
          return val
          // this.changeContent = val
        }
      },
      evaltList(){
        let CourseId = getLocalStorage('Id')
        let params = {

          courseId: CourseId,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        }
        http.post('/course/evaluateList.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
             this.commentList = res.data.model
             if(this.commentList=='0'){
              this.src='./static/image/user.png'
             }else{
               this.commentList = res.data.model
             }
             console.log(this.commentList,'-------------------')
            for (let item of this.commentList) {
              item.createDate = nomalTime(item.createDate)
              item.content=item.content
              if(item.img==undefined){
                 item.img='./static/image/user.png'
              }else{
                 item.createDate = nomalTime(item.createDate)
              }
              // item.img = `${window.BASE_URL}${item.img}`
            }
             this.page.total = res.data.totalItem
          } else {
            this.page.total = 0
          }
        })
      },

      __currentPage(payload) { //选择页数
        this.page.currentPage = payload
        this.evaltList()
      },
      __pageSize(payload) {  //选择每页多少条
        this.page.pageSize = payload
        this.evaltList()
      },

    },
    created() {
      this.evaltList()
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .review
    .noData
      min-height: calc(100vh - 467px)
      line-height: calc(100vh - 467px)
      text-align: center
      font-size: 15px
      position: relative
      background:url('../../../../static/image/defaultpic.png') no-repeat  50%
      background-size:150px 100px;
    .reviewCont
       padding: 0 20px
       box-sizing: border-box
       // height: calc(100vh - 467px)
       height auto
       overflow-y: auto
       margin-bottom: 9px
       li
         height: 130px
         border-bottom: 1px solid #e9e6e6
         padding-top: 30px
         box-sizing: border-box
         overflow: hidden
         img
           width: 55px
           height: 55px
           border-radius: 50%
           overflow: hidden
           float: left
           margin-right: 15px
         .paramCont
           line-height: 45px
           float: left
           height: 100%
           .paramName
             color: #000000
             font-weight: bold
             font-size: 15px
           .star
             margin-left: 20px
             position: relative
             top: 1px
             .iconfont
                margin: 0 3px
           .paramTime
             float: right
             width:30%
           p
             line-height: 23px
             height: 46px
             overflow: hidden
             margin-top: 7px
             color: #8a8989
</style>



// WEBPACK FOOTER //
// review.vue?449c50ee